import First from "../../../../../assets/images/project/masjid/MASJID_DARUSSALAM/masjid-pnf-resolusi-1920x1080.jpg";

export default [
  {
    title: "Darussalam Mosque",
    description: "Masjid modern minimalis",
    urls: First,
  },
];
